const dateToDateString = (date) => {
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return [year, month, day].join("-");
};
const dateToTimeString = (date) => {
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return [hours, minutes, "00"].join(":");
};
const dateToDateTimeString = (date) => {
  return [dateToDateString(date), dateToTimeString(date)].join(" ");
};
export {
  dateToDateString,
  dateToDateTimeString,
  dateToTimeString
};
//# sourceMappingURL=utils.js.map
